module.exports = __webpack_public_path__ + "img/financial-report.3db6cf9b.svg";